// http://192.168.0.74:9999// http://zht-api.hebeigaoda.com/
export default {
  baseUrl: {
    pro: 'https://zht-api.hebeigaoda.com/',
    dev: 'http://127.0.0.1:8888/',
    uat:'https://zht-api.hebeigaoda.com/'
  },
  oss: {
    dev: 'https://gdhy-oss.hebeigaoda.com/',
    pro: 'https://gdhy-oss.hebeigaoda.com/',
    uat:'https://gdhy-oss.hebeigaoda.com/'
  }
}

